import React, { Component, PureComponent, Fragment } from 'react'
import { Group, Form, Field, Columns, Submit, InfoGroup, Info } from '~/form'

export let ArticleFormValidations = {
  title: ['required'],
}

export default class ArticleForm extends Component {
  render() {
    let { title, formUpdate, formSubmit, formState, formLoading } = this.props

    return (
      <Group title={title}>
        <Field
          placeholder="Otsikko"
          size="large"
          type="text"
          name="title"
          onChange={formUpdate}
          formState={formState}
        />
        <Field type="wysiwyg" name="content" onChange={formUpdate} formState={formState} />
      </Group>
    )
  }
}
